import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a13ba9d"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "table-header-year",
  role: "columnheader"
}, "年度", -1))
const _hoisted_2 = { class: "text-wrap" }
const _hoisted_3 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RemoveButton = _resolveComponent("RemoveButton")!

  return (_openBlock(), _createElementBlock("div", {
    class: "term-edit-table-header-container",
    role: "row",
    style: _normalizeStyle(_ctx.styles)
  }, [
    _hoisted_1,
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.maxTermNumber, (termNumber) => {
      return (_openBlock(), _createElementBlock("div", {
        key: termNumber,
        class: "table-header-term",
        role: "columnheader"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("span", _hoisted_3, _toDisplayString(termNumber) + "学期", 1),
          (_ctx.editing && termNumber === _ctx.maxTermNumber)
            ? (_openBlock(), _createBlock(_component_RemoveButton, {
                key: 0,
                class: "remove-button",
                "aria-label": "Delete Term",
                "on-click": _ctx.deleteTermNumber
              }, null, 8, ["on-click"]))
            : _createCommentVNode("", true)
        ])
      ]))
    }), 128))
  ], 4))
}